module.exports = __webpack_public_path__ + "images/top-movers-fa4eea49.svg";